import { createApp } from 'vue'
import App from './App.vue'

// Pinia setup
import pinia from './store/index' // Import the updated Pinia instance
import Aura from '@primeuix/themes/aura'

// PrimeVue setup
import PrimeVue from 'primevue/config'
import Panel from 'primevue/panel'
import Button from 'primevue/button'

import 'primeicons/primeicons.css' // PrimeVue Icons
import './style.css' // Global styles
import { loadAllPiniaModelData } from './utils/hydratePinia'
import ConfirmationService from 'primevue/confirmationservice'
import { inject } from '@vercel/analytics'

// Create Vue App
const app = createApp(App)
app.use(PrimeVue, {
  // Default theme configuration
  theme: {
    preset: Aura,
    options: {
      prefix: 'p',
      darkModeSelector: 'system',
      cssLayer: false,
    },
  },
})
app.use(pinia)

// Register PrimeVue components globally
app.use(ConfirmationService)

loadAllPiniaModelData()

// Collect analytics data
inject()

app.mount('#app')
